module.exports = __webpack_public_path__ + "img/title.f8d1c75f.png";